import {MathUtils} from "../mathUtils";
import {Vector2} from "../delme_globals";
import {THREE} from "../resource/BVH.js";
import {CONSTANTS} from "../meta_data";
import globalsObject from "../globalsObject";
import {OwayoJSKonfiViewer} from "../owayoJSViewerWithSelObs";



export class OwayoMouseInfoObject {
    onclick:Vector2;
    current:Vector2;
    rotationOnMouseDown : Vector2;
    isTouch  = false;
    ctrlKey  = false;
    cameraPositionOnMouseDown : THREE.Vector3;

    constructor() {
        this.cameraPositionOnMouseDown = new THREE.Vector3(0,0,0);
        this.onclick = new Vector2();
        this.current = new Vector2();
        this.rotationOnMouseDown = new Vector2(0,0);
    }
}


export class ViewerPointerDeviceHandler {
    public mouseInfo : OwayoMouseInfoObject;
    public mouseMoveInAction = false;
    private readonly container;

    public constructor(container) {
        this.container = container;
        this.mouseInfo = new OwayoMouseInfoObject();
        this.initEventListeners();
    }

    private initEventListeners() {
        window.addEventListener( 'touchmove',(event)=>this.touchMoveEventHandler(event), {passive: true} );
        const elementById = this.container;
        elementById.addEventListener( 'mousemove',(event)=>this.mouseMoveEventHandler(event), {passive: true} );
        elementById.addEventListener( 'mousedown',event=>this.onDocumentMouseDown(event), {passive: true});
        elementById.addEventListener( 'touchstart',event=>this.onDocumentTouchStart(event), {passive: true});
        elementById.addEventListener( 'mousewheel',(event)=>ViewerPointerDeviceHandler.onMouseWheel(event), {passive: true} );
        elementById.addEventListener( 'DOMMouseScroll',(event)=>ViewerPointerDeviceHandler.onMouseWheel(event), {passive: true} );
        this.container.addEventListener('dblclick',()=>globalsObject.owayoJSViewer.doDblClick());
    }

    private mouseMoveEventHandler(event) {
        this.setCurrentPointerPositionFromMouseEvent(event);
        if (globalsObject.owayoJSViewer.selectedObjectPresentButNotInitialized()) {
            return; //Wir wollen nichts mit dem Object anstellen, wenn wir nicht fertig initialisiert sind
        }
        globalsObject.owayoJSViewer.doMouseMove();
    }

    private touchMoveEventHandler(event) {
        this.setCurrentPointerDataFromTouchEvent(event);
        if(event.touches.length !== 1) {
            return;
        }
        if (event.currentTarget.id === globalsObject.owayoJSViewer.container.id) {
            event.stopPropagation();
        }
        globalsObject.owayoJSViewer.doMouseMove();
    }

    protected setCurrentPointerDataFromTouchEvent(event ) {
        if ( event.touches.length === 1 ) {
            this.mouseInfo.current.x = event.touches[ 0 ].pageX ;
            this.mouseInfo.current.y = event.touches[ 0 ].pageY ;
        }
    }

    protected setCurrentPointerPositionFromMouseEvent(event ) {
        this.mouseInfo.current.x = event.pageX ;
        this.mouseInfo.current.y = event.pageY ;
    }

    public getMouseInContainer(offset:{top, left}):Vector2 {
        return new Vector2(this.mouseInfo.current.x - offset.left, this.mouseInfo.current.y - offset.top);
    }

    public getMouseInContainerOnClick(offset:{top, left}):Vector2 {
        return new Vector2(this.mouseInfo.onclick.x - offset.left, this.mouseInfo.onclick.y - offset.top);
    }

    public mouseHasMovedLessThan(distance) {
        return (MathUtils.distSquared(
            new Vector2(this.mouseInfo.current.x,this.mouseInfo.current.y),
            new Vector2(this.mouseInfo.onclick.x,this.mouseInfo.onclick.y)
        ) < distance);
    }

    public setCameraPositionOnMouseDown(position) {
        this.mouseInfo.cameraPositionOnMouseDown = OwayoJSKonfiViewer.cloneXYZObject(position);
    }

    public setRotationOnMouseDown(rotation) {
        this.mouseInfo.rotationOnMouseDown = rotation;
    }

    public isCTRLKeyPressed() {
        return this.mouseInfo.ctrlKey;
    }

    getCameraPositionOnMouseDown() {
        return this.mouseInfo.cameraPositionOnMouseDown;
    }

    private onDocumentMouseDown( event ) {

        this.mouseInfo.current = new Vector2(event.pageX, event.pageY);
        this.mouseInfo.onclick = new Vector2(event.pageX, event.pageY);
        this.mouseInfo.ctrlKey = event.ctrlKey;
        this.mouseInfo.rotationOnMouseDown = globalsObject.owayoJSViewer.getModelRotation();
        this.mouseInfo.isTouch = false;
        globalsObject.owayoJSViewer.setNewInteractionMode();
    }

    private onDocumentTouchStart( event ) {
        this.mouseInfo.isTouch = true;
        if ( event.touches.length === 1 ) {

            this.mouseInfo.current = new Vector2(event.touches[ 0 ].pageX, event.touches[ 0 ].pageY);
            this.mouseInfo.onclick = new Vector2(event.touches[ 0 ].pageX, event.touches[ 0 ].pageY);
            this.mouseInfo.ctrlKey = event.ctrlKey;
            this.mouseInfo.rotationOnMouseDown = globalsObject.owayoJSViewer.getModelRotation();
            globalsObject.owayoJSViewer.setNewInteractionMode();
        }
    }

    getRotationOnMouseDown = ()=>this.mouseInfo.rotationOnMouseDown;
    getMouseDeltaSinceClick = ()=>Vector2.componentSubtract(this.mouseInfo.current, this.mouseInfo.onclick);


    private static onMouseWheel(event) {
        let rolled;
        if (typeof(event.wheelDelta) !== "undefined") {
            rolled = event.wheelDelta;
        }
        else {  // Firefox
            // The measurement units of the detail and wheelDelta properties are different.
            rolled = -40 * event.detail;
        }
        rolled = rolled / 140;
        globalsObject.owayoJSViewer.zoomController.zoomOnMouseWheel(rolled, new Vector2(event.clientX, event.clientY))
    }

    startMouseMoveInAction() {
        this.mouseMoveInAction = true;
        setTimeout(()=>this.mouseMoveInAction = false, 1000 / CONSTANTS.MOUSE_PS_LIMIT);
    }

    getMouseInContainerAsValueBetweenPlusMinusOne(viewerDimesion: { width, height }, offset):Vector2 {
        const mouseInContainer = this.getMouseInContainer(offset);
        let MouseInContainerX = mouseInContainer.x / viewerDimesion.width;
        let MouseInContainerY = mouseInContainer.y / viewerDimesion.height;

        // Wir wollen jedoch keinen Wert von 0 bis 1 wie bei einer UV-Map  sondern einen
        // Wert von -1 bis 1 .  Dafür wird der Wert verdoppelt und dann um 1 verschoben.
        // Bei Y wollen wir ausserdem die Logik umdrehen da der Browser die 0 oben setzt und 1 unten
        // un ThreeJS erwartet -1 unten und 1 oben.
        MouseInContainerX = MouseInContainerX * 2 -1;
        MouseInContainerY = -MouseInContainerY *2 +1;
        return new Vector2(MouseInContainerX, MouseInContainerY);
    }
}